module.exports = "<svg>\r\n  <circle kd-circle__track\r\n      cx=\"10\"\r\n      cy=\"10\"\r\n      r=\"8\"\r\n      fill=\"none\"\r\n      stroke-width=\"3\"></circle>\r\n  <circle kd-circle__path\r\n      cx=\"10\"\r\n      cy=\"10\"\r\n      r=\"8\"\r\n      fill=\"none\"\r\n      stroke-width=\"3\"\r\n      stroke-miterlimit=\"10\"></circle>\r\n</svg>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/kendu/ui/components/kd-progress-circular/template.html
// module id = 314
// module chunks = 0